import { render, staticRenderFns } from "./AdminPublicProducts.vue?vue&type=template&id=6ca4db69&scoped=true&"
import script from "./AdminPublicProducts.vue?vue&type=script&lang=js&"
export * from "./AdminPublicProducts.vue?vue&type=script&lang=js&"
import style0 from "../../../../assets/css/admin-section.css?vue&type=style&index=0&id=6ca4db69&prod&scoped=true&lang=css&"
import style1 from "./AdminPublicProducts.vue?vue&type=style&index=1&id=6ca4db69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca4db69",
  null
  
)

export default component.exports